module.exports = __webpack_public_path__ + "img/kopsurat_semin.f7e51adc.png";